import {useMemo} from 'react';
import type {TableAction} from 'schema/table/types';
import {useLocalization} from 'localization';
import {useCreateMergeSuggestionMutation} from 'services/mergeSuggestions/mergeSuggestionsApi';
import {useSnacks} from 'components';

export const useAddMergeSuggestionAction = (): TableAction => {
  const [createMergeSuggestion] = useCreateMergeSuggestionMutation();
  const {successSnack, errorSnack} = useSnacks();
  const {t} = useLocalization();

  return useMemo(() => {
    return {
      name: 'addMergeSuggestionAction',
      label: t('page.mergeSuggestion.action.addMergeSuggestion.label'),
      onClick: (row, activeId) => {
        if (activeId && row?.['id']) {
          createMergeSuggestion({
            targetId: activeId,
            sourceId: row['id'],
            type: 'WORK',
          })
            .then(() =>
              successSnack(
                t('page.mergeSuggestion.action.addMergeSuggestion.created'),
              ),
            )
            .catch(() =>
              errorSnack(
                t('page.mergeSuggestion.action.addMergeSuggestion.failed'),
              ),
            );
        }
      },
    };
  }, [createMergeSuggestion, errorSnack, successSnack, t]);
};
